module.exports = __webpack_public_path__ + "static/media/fj.b536bc5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fj.png
// module id = 1845
// module chunks = 0